import React from 'react'

function Menu() {
  return (
    <div className='menu'>
      <div className="links-holder">
        <div className='dummy-link'>Live TV</div>
        <div className='dummy-link'>Politics</div>
        <div className='dummy-link'>Business</div>
        <div className='dummy-link'>Sports</div>
      </div>
      <img src="img/idan.jpeg" alt="idann" />
    </div>
  )
}

export default Menu
